import { Wrench, Clock, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center space-y-6">
          {/* Icon */}
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Wrench className="h-8 w-8 text-primary" />
          </div>
          
          {/* Title */}
          <div className="space-y-2">
            <h1 className="text-2xl font-bold">Wartungsarbeiten</h1>
            <p className="text-muted-foreground">
              Wir führen gerade wichtige Systemupdates durch
            </p>
          </div>
          
          {/* Content */}
          <div className="space-y-4">
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" />
              <span>Voraussichtliche Dauer: 30-60 Minuten</span>
            </div>
            
            <p className="text-sm text-muted-foreground leading-relaxed">
              Wir arbeiten daran, Ihr Erlebnis zu verbessern. 
              Bitte versuchen Sie es in wenigen Minuten erneut.
            </p>
          </div>
          
          {/* Actions */}
          <div className="space-y-3">
            <Button 
              onClick={() => window.location.reload()} 
              className="w-full"
            >
              Seite neu laden
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            
            <p className="text-xs text-muted-foreground">
              Bei Fragen erreichen Sie uns unter{' '}
              <a 
                href="mailto:support@herzensempfehlung.de" 
                className="text-primary hover:underline"
              >
                support@herzensempfehlung.de
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default MaintenancePage